import React from "react";
import { Progress, Space } from "antd";

interface Props {
    currentAmount: number;
    totalAmount: number;
    variant?: "circle" | "line";
}

export const FixedOverfullProgressBar: React.FC<Props> = ({ currentAmount, totalAmount, variant = "circle" }) => {
    const isOverfull = currentAmount > totalAmount;
    const success = currentAmount === totalAmount;
    // Calculate the percentage, but cap it at 100 for the visual bar
    const percent = Math.min((currentAmount / totalAmount) * 100, 100);
    const status = success ? 'success' : isOverfull ? 'exception' : 'normal';
    const label = `${currentAmount} / ${totalAmount}`;

    if (variant === "line") {
        return (
            <Progress
                type="line"
                className={isOverfull ? 'overfull' : ''}
                percent={percent}
                size="small"
                format={() => <span style={{ fontSize: 11, fontWeight: 500 }}>{label}</span>}
                status={status}
            />
        );
    }

    return (
      <Space direction="vertical" style={{ width: '100%' }}>
        <Progress
          type="circle"
          size={80}
          className={isOverfull ? 'overfull' : ''} // Apply the overfull class
          percent={percent} // Visual bar is capped at 100
          format={() => <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
            {label}
            </span>} // Text shows real values
          status={status} // Change color if overfull
        />
      </Space>
    );
};
